<article
  class="offer"
  (click)="selectOffer(typeOffer, previewOffer)"
  [ngClass]="{ twelve: typeOffer == '12' }"
>
  <ng-container *ngIf="typeOffer == '12'">
    <div class="offer__tag">
      <div class="offer__tag__container">
        <img src="/assets/icons/white-circle-money.svg" alt="Ícono de dinero" />
        <p>¡Cuota más baja!</p>
      </div>
    </div>
  </ng-container>
  <div class="offer__details" [ngClass]="{ twelve: typeOffer == '12' }">
    <div class="offer__details__option">
      <div class="offer__details__option__left">
        <div class="check-box" [ngClass]="{ activeOffer: selected == typeOffer }">
          <span></span>
        </div>
        <label for="amount"
          ><b>{{ typeOffer }} cuotas </b
          ><span class="debt">{{
            previewOffer?.installments[0].amount | powerpayCurrency
          }}</span></label
        >
      </div>
    </div>
    <div class="offer__details__promo">
      <!-- <b>{{ onSetTotalCostsToNumber() === 0 ? seeLessTitle : seeLoanSummaryTitle }}</b> -->
      <b>{{
        offer.repayment_frequency.minimum_installments === 3
          ? threeInstallments
          : offer.repayment_frequency.minimum_installments === 6
          ? sixInstallments
          : offer.repayment_frequency.minimum_installments === 12
          ? twelveInstallments
          : defaultText
      }}</b>
    </div>
    <!-- <div class="offer__details__charges">
      TCEA
      <b>{{ previewOffer?.details.tcea | number : '1.2-2' : 'en-US' }}%</b>
    </div> -->
    <div class="offer__details__container" [ngClass]="{ show: showLoanSummary }">
      <ng-container *ngFor="let installment of previewOffer?.installments; let i = index">
        <div class="offer__details__container__installment">
          <div class="dotline"></div>
          <div class="bot">
            <div class="bot__left">
              <div class="bot__left__number" [ngClass]="{ twelve: typeOffer == '12' && i == 0 }">
                <b>{{ i + 1 }}/{{ installments.length }}</b>
              </div>
              <div class="bot__left__amount" [ngClass]="{ twelve: typeOffer == '12' && i == 0 }">
                <b>{{ installment.amount | powerpayCurrency }}</b>
              </div>
            </div>
            <div *ngIf="i === 0" class="date-today" [ngClass]="{ twelve: typeOffer == '12' }">
              <b>Hoy</b>
            </div>
            <div *ngIf="i !== 0" class="date">
              {{ installment.payday | dayName }}
              <br />
              {{ installment.payday | date : 'd MMM, y' | uppercase }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="offer__details__summary" [ngClass]="{ show: showLoanSummary }">
      <home-summary
        [offerSelected]="offerSelected"
        [amount]="amount"
        [previewOffer]="previewOffer"
      ></home-summary>
    </div>
  </div>
  <button class="offer__button" (click)="onShowLoanSummary()">{{ buttonName }}</button>
</article>
